<kendo-appbar [position]="'bottom'">
  <kendo-appbar-section>
    <span style="font-weight:600;font-size:12px;">Copyright BRE 2021</span>
  </kendo-appbar-section>
</kendo-appbar>
